import { mdiStorePlus } from '@mdi/js'

export default [
  {
    title: 'محصولات',
    icon: mdiStorePlus,
    action: 'can_see_products_menu',
    resource: 'all',
    children: [
      {
        title: 'محصولات دیجیتال',
        to: 'gifts',
        action: 'can_see_product_digital',
        resource: 'all',
      },
      {
        title: 'ساختار محصولات',
        to: 'structure-product',
        action: 'can_edit_structure',
        resource: 'all',
      },
      {
        title: 'مپ داخلی',
        to: 'internal-mapping',
        action: 'can_see_internal_mapping',
        resource: 'all',
      },
    ],
  },
]
